// *********************************
// CoolGames Builder JavaScript file
// *********************************
export var Events = {
    POWERUP_CLICKED: "POWERUP_CLICKED",
    POWERUP_CANCELED: "POWERUP_CANCELED",
    DISCONNECTED: "DISCONNECTED"
};
